import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["containerProps", "imageProps", "title", "titleProps", "contentProps", "shadow", "background", "borderRadius", "collapsible", "defaultExpanded", "className", "children"],
  _excluded2 = ["background", "border", "borderColor", "borderRadius", "shadow", "title", "titleProps", "children", "footer", "padding", "className"],
  _excluded3 = ["type", "containerProps", "imageProps", "title", "titleProps", "contentProps", "shadow", "background", "borderRadius", "border", "borderColor", "footer", "padding", "collapsible", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import DixuContainer from "../DixuContainer/DixuContainer";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuText from "../DixuText/DixuText";
import DixuTitle from "../DixuTitle/DixuTitle";
import React, { useEffect, useState } from 'react';
import { useCollapse } from 'react-collapsed';
const DixuCardDefault = _ref => {
  let {
      containerProps,
      imageProps,
      title,
      titleProps,
      contentProps,
      shadow,
      background,
      borderRadius,
      collapsible,
      defaultExpanded,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    getCollapseProps,
    getToggleProps,
    isExpanded
  } = useCollapse({
    defaultExpanded,
    duration: 300
  });
  const {
    0: renderContent,
    1: setRenderContent
  } = useState(defaultExpanded);
  const classes = classNames('dixu-card--default', className, {
    [`box-shadow-${shadow}`]: shadow,
    [`bg-${background}`]: background,
    [`border-radius-${borderRadius}`]: borderRadius
  });
  useEffect(() => {
    if (!renderContent && isExpanded) {
      setRenderContent(true);
    }
  }, [renderContent, isExpanded]);
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), imageProps && /*#__PURE__*/React.createElement(DixuImage, _objectSpread({
    aspectRatio: '2:1'
  }, imageProps)), /*#__PURE__*/React.createElement(DixuContainer, _objectSpread({
    noOverflow: false,
    maxWidth: false,
    horizontalPadding: 'lg',
    verticalPadding: 'lg',
    centerHorizontally: false,
    dynamicPadding: false,
    height: 'full'
  }, containerProps), title && /*#__PURE__*/React.createElement("div", _objectSpread({
    className: 'dixu-card__title-wrapper'
  }, collapsible ? getToggleProps() : {}), /*#__PURE__*/React.createElement(DixuTitle, _objectSpread(_objectSpread({
    level: '2',
    appear: '3',
    color: '2-8',
    weight: 'bold',
    noSemantics: true,
    responsive: false
  }, titleProps), {}, {
    margin: 0,
    className: classNames('dixu-card__title', titleProps?.className)
  }), /*#__PURE__*/React.createElement(DixuRow, {
    justify: "space-between",
    align: "middle",
    gutter: 16,
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, {
    flex: "1 1 auto"
  }, title), collapsible && /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(RightOutlined, {
    rotate: isExpanded ? 90 : 0
  }))))), /*#__PURE__*/React.createElement("div", _objectSpread({}, collapsible ? getCollapseProps({
    className: 'dixu-card__content-wrapper'
  }) : {
    className: classNames('dixu-card__content-wrapper', {
      'dixu-card__content-wrapper--collapsible': collapsible
    })
  }), /*#__PURE__*/React.createElement(DixuText, _objectSpread(_objectSpread({
    font: '3',
    color: '2-8'
  }, contentProps), {}, {
    tag: 'div',
    className: classNames('dixu-card__content', {
      [`p-t-${titleProps?.margin || 8}`]: title
    }, contentProps?.className)
  }), renderContent && children))));
};
DixuCardDefault.defaultProps = {
  background: '2-1',
  borderRadius: 'lg'
};
const DixuCardBordered = _ref2 => {
  let {
      background,
      border,
      borderColor,
      borderRadius,
      shadow,
      title,
      titleProps,
      children,
      footer,
      padding,
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-card--bordered', {
    [`bg-${background}`]: background,
    [`border-${border}`]: border,
    [`border-color-${borderColor}`]: borderColor,
    [`border-radius-${borderRadius}`]: borderRadius,
    [`box-shadow-${shadow}`]: shadow,
    [`p-${padding}`]: padding
  }, className);
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "dixu-card__content"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, title && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle, _objectSpread({
    level: '5',
    weight: 'bold',
    margin: '0',
    noSemantics: true,
    hyphens: true
  }, titleProps), title)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: '3',
    color: '2-8',
    weight: 'medium',
    block: true
  }, children)))), footer && /*#__PURE__*/React.createElement("div", {
    className: "m-t-16"
  }, footer)));
};
DixuCardBordered.defaultProps = {
  background: '2-1',
  border: 'xs',
  borderRadius: 'md',
  borderColor: '2-4',
  shadow: '1',
  padding: 16
};
const DixuCard = _ref3 => {
  let {
      type,
      containerProps,
      imageProps,
      title,
      titleProps,
      contentProps,
      shadow,
      background,
      borderRadius,
      border,
      borderColor,
      footer,
      padding,
      collapsible,
      className,
      children
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  const classes = classNames('dixu-card', {
    [[].concat(collapsible).map(e => `dixu-card--collapsible-${e}`).join(' ')]: collapsible
  }, className);
  if (type === 'default') {
    return /*#__PURE__*/React.createElement(DixuCardDefault, _objectSpread({
      className: classes,
      containerProps,
      imageProps,
      title,
      titleProps,
      contentProps,
      shadow,
      background,
      borderRadius,
      collapsible,
      children
    }, rest));
  }
  if (type === 'bordered') {
    return /*#__PURE__*/React.createElement(DixuCardBordered, _objectSpread({
      className: classes,
      background,
      border,
      borderColor,
      borderRadius,
      shadow,
      title,
      titleProps,
      footer,
      padding,
      children
    }, rest));
  }
  return null;
};
DixuCard.defaultProps = {
  type: 'default',
  containerProps: undefined,
  imageProps: undefined,
  title: undefined,
  titleProps: undefined,
  contentProps: undefined,
  shadow: undefined,
  background: undefined,
  borderRadius: undefined,
  border: undefined,
  borderColor: undefined,
  footer: undefined,
  padding: undefined,
  collapsible: false,
  defaultExpanded: true
};
export default DixuCard;